__turbopack_context__.v({
  "PromoStylistCardSmall": "styles-module-scss-module___L2aiW__PromoStylistCardSmall",
  "quotationMark": "styles-module-scss-module___L2aiW__quotationMark",
});
